import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ClientsControlState } from '../reducers/clients-control.reducer';

export const selectClientsControlState =
  createFeatureSelector<ClientsControlState>('clientsControlData');

export const selectClientsControlData = createSelector(
  selectClientsControlState,
  (state: ClientsControlState) => state.data
);
